import { ref, unref } from "vue";
import QuilityAPI from '@/store/API/QuilityAPI.js'

const createScript = (src) => {
	return new Promise((resolve, reject) => {
		const script = document.createElement('script')
		script.src = src
		script.async = true
		script.id = 'ze-snippet'
		script.onload = resolve
		script.onerror = reject
		document.head.appendChild(script)
	})
}

export default {
    install(app) {
		const disabled = ref(true)
	  	const queue = []
		const fakezE = (...args) => {
			queue.push(args)
		}

        app.prototype.$zendesk = {
            async initialize(options) {
				try {
					const API_KEY = process.env.VUE_APP_ZENDESK_API_KEY
					await createScript(`https://static.zdassets.com/ekr/snippet.js?key=${API_KEY}`)
					console.log('Zendesk script loaded')
				} catch (e) {
					console.error('Failed to load Zendesk script', e)
				}

				window.zE('messenger:set', 'conversationFields', options, () => {
					disabled.value = false
				})

				if (queue.length) {
					queue.forEach(args => window.zE(...args))
				}
			},
			get zE() {
				if (!window.zE) {
					return fakezE
				}
				return window.zE
			},
			async loginUser() {
				this.zE('messenger', 'loginUser',
					(callback) => {
						QuilityAPI.getZendeskJWT().then(({ token }) => {
							callback(token)
						})
					},
					(error) => {
						if (error) {
							console.error('[Zendesk]: User was unable to log in..', error)
						} else {
							console.log('[Zendesk]: User has successfully logged in.')
						}
						disabled.value = false
					},
				)
			},
			async logoutUser() {
				this.zE('messenger', 'logoutUser')
				disabled.value = true
			},
			get disabled () {
				return unref(disabled)
			},
        }
    }
}
